import { createFileRoute } from "@tanstack/react-router"
import { AuthRoute } from "@/app"

export const Route = createFileRoute("/$locale/auth")({
  component: RouteComponent,
})

function RouteComponent() {
  return <AuthRoute />
}
